import React from "react";
import ProductSelector from "./ProductSelector";
import { formatCLP } from "../../Helper/Cotizacion/currencyUtils";
import { DISCOUNT_TYPES } from "../../Helper/Cotizacion/quoteCalculations";
import { getProductById } from "../../Helper/Cotizacion/mockProducts";

const QuoteItemRow = ({ item, index, onChange, onRemove }) => {
	const handleProductSelect = (productId) => {
		const product = getProductById(productId);
		if (!product) {
			onChange(index, { ...item, productId: "" });
			return;
		}
		onChange(index, {
			...item,
			productId: product.id,
			nombre: product.nombre,
			descripcion: product.descripcion,
			precioUnitario: product.precioNeto,
		});
	};

	const handleField = (event) => {
		const { name, value } = event.target;
		let nextValue = value;

		if (name === "cantidad" || name === "precioUnitario" || name === "valorDescuento") {
			nextValue = value === "" ? "" : Math.max(0, Number(value));
		}

		onChange(index, { ...item, [name]: nextValue });
	};

	return (
		<div
			style={{
				border: "1px solid #e2e8f0",
				borderRadius: "8px",
				padding: "12px",
				marginBottom: "12px",
				background: "#fff",
			}}
		>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "8px",
				}}
			>
				<strong>Ítem {index + 1}</strong>
				<button
					type="button"
					className="button alert hollow tiny"
					style={{ marginBottom: 0 }}
					onClick={() => onRemove(index)}
				>
					Eliminar
				</button>
			</div>

			<div className="grid-x grid-margin-x">
				<div className="cell small-12 medium-6">
					<ProductSelector value={item.productId} onSelect={handleProductSelect} />
				</div>
				<div className="cell small-12 medium-6">
					<label>
						Nombre
						<input
							type="text"
							name="nombre"
							value={item.nombre}
							onChange={handleField}
							placeholder="Nombre del servicio"
						/>
					</label>
				</div>
				<div className="cell small-12">
					<label>
						Descripción
						<textarea
							name="descripcion"
							rows={2}
							value={item.descripcion}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-6 medium-3">
					<label>
						Cantidad
						<input
							type="number"
							name="cantidad"
							min="1"
							value={item.cantidad}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-6 medium-3">
					<label>
						Precio unitario
						<input
							type="number"
							name="precioUnitario"
							min="0"
							value={item.precioUnitario}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-6 medium-3">
					<label>
						Tipo descuento
						<select
							name="tipoDescuento"
							value={item.tipoDescuento || DISCOUNT_TYPES.NONE}
							onChange={handleField}
						>
							<option value={DISCOUNT_TYPES.NONE}>Sin descuento</option>
							<option value={DISCOUNT_TYPES.PERCENT}>Porcentaje</option>
							<option value={DISCOUNT_TYPES.FIXED}>Monto fijo</option>
						</select>
					</label>
				</div>
				<div className="cell small-6 medium-3">
					<label>
						Valor descuento
						<input
							type="number"
							name="valorDescuento"
							min="0"
							value={item.valorDescuento}
							onChange={handleField}
							disabled={item.tipoDescuento === DISCOUNT_TYPES.NONE}
						/>
					</label>
				</div>
			</div>

			<div
				style={{
					display: "flex",
					justifyContent: "flex-end",
					gap: "16px",
					fontSize: "13px",
					marginTop: "4px",
				}}
			>
				<span>Subtotal: {formatCLP(item.subtotal || 0)}</span>
				<span>Desc.: {formatCLP(item.montoDescuento || 0)}</span>
				<strong>Total línea: {formatCLP(item.total || 0)}</strong>
			</div>
		</div>
	);
};

export default QuoteItemRow;
